interface ThumbsUpIconProps {
  className?: string;
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const ThumbsUpIcon = ({ className = 'w-6 h-6', color = '#F357BB' }: ThumbsUpIconProps) => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" className={className}>
    {/* Paste Figma SVG content here */}
    <path
      d="M5 21.1255V9.625C5 9.00368 5.50368 8.5 6.125 8.5C6.74632 8.5 7.25 9.00368 7.25 9.625V21.1255C7.24974 21.7466 6.74616 22.2505 6.125 22.2505C5.50384 22.2505 5.00026 21.7466 5 21.1255Z"
      fill={color}
    />
    <path
      d="M12 3.62549C12 2.8661 11.3839 2.25 10.6245 2.25H10.3784L7.16455 10.0532C6.99094 10.4747 6.58034 10.7505 6.12451 10.7505H4.125C3.08947 10.7505 2.25 11.59 2.25 12.6255V18.1245C2.25 19.16 3.08947 19.9995 4.125 19.9995H17.0508C17.9762 19.9995 18.763 19.3248 18.9038 18.4102L19.9819 11.4097C20.1563 10.2741 19.2764 9.25049 18.1274 9.25049H13.125C12.5038 9.25049 12.0003 8.74658 12 8.12549V3.62549ZM14.25 7.00049H18.1274C20.5763 7.00049 22.4681 9.11444 22.2349 11.5181L22.2056 11.7524L21.1289 18.7529C20.8191 20.7649 19.0866 22.2495 17.0508 22.2495H4.125C1.84683 22.2495 0 20.4027 0 18.1245V12.6255C0 10.3473 1.84683 8.50049 4.125 8.50049H5.37158L8.3291 1.31543L8.39648 1.17041C8.75498 0.45703 9.4875 0 10.2949 0H10.6245C12.6265 0 14.25 1.62346 14.25 3.62549V7.00049Z"
      fill={color}
    />
  </svg>
);
